import React from 'react';
import Home7 from "../../components/incluvia";

const Incluvia = () => {
    return (
            <>
                <Home7 />
            </>
    );
};

export default Incluvia;
